import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcsnssnh72: FaireProductEntity = {
  token: "p_gcsnssnh72",
  type: "product",
  name: "Big Dick Energy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/df0eabf962251afaf8711a9c4941682d78b5e600f635bb66cc1efb87d832f937.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/016156c89f46f7b4100f69a724c8cb5564d1cf4cf26ba47683c8914131df59dc.jpeg",
    "https://cdn.faire.com/fastly/90e22a04767bfdcfdebc90285c5c08d7d4cf14b235377e750266e51aa1c90845.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/88cfcf78f5753a9470554ee7c88509fb0d41c676d8af6b72d7fb6c50a81184b9.jpeg",
    "https://cdn.faire.com/fastly/f32e53b506208b862265162455b16677884290e0e53a1fa27181b496541c217f.jpeg"
  ],
  priceDollars: 6.75,
  description: "Big dicks are over rated... that energy though??? 😋 Step softly and carry a big..... stick... in these comfy gym socks!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:58.358Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
